const couponHelper = module.exports = {};

couponHelper.ABSOLUTE = 'absolute';
couponHelper.RELATIVE = 'relative';
